// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._3Ut1{align-items:flex-start;display:flex;gap:.5rem}._3Ut1 .E2tU9{display:flex;flex-direction:column;gap:.5rem}._3Ut1 .E2tU9 .EKXhM{align-items:center;display:flex}._3Ut1 .E2tU9 .EKXhM div{display:inline-block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sideNavItemPopupContent": `_3Ut1`,
	"policyContent": `E2tU9`,
	"policyLink": `EKXhM`
};
module.exports = ___CSS_LOADER_EXPORT___;
